<template>
  <q-select
    v-model="itemSelect"
    name="system-item"
    :options="options"
    outlined
    clearable
    dense
    emit-value
    map-options
    :error="props.error"
    hide-bottom-space
    style="background: var(--q-white); max-width: 400px"
  >
    <template #default>
      <div v-if="!itemSelect" style="position: absolute; top: 5px">
        <span class="text-dark">選択してください</span>
      </div>
    </template>
  </q-select>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';
import SystemImportItemCode, { SystemImportItemName } from '../../common/code/SystemImportItemCode';

interface Props {
  id: string;
  error: boolean;
}

interface SystemItemSelect {
  label: string;
  value: string;
}

const props = defineProps<Props>();
const emit = defineEmits(['selectItem']);

// 選択値
const itemSelect = computed({
  get: () => props.id,
  set: (value) => {
    emit('selectItem', value || '');
  },
});

// プルダウン内容
const options = ref<SystemItemSelect[]>([]);

/**
 * 初期処理
 */
// プルダウン内容を設定
Object.entries(SystemImportItemName).forEach(([key, value]) => {
  options.value.push({
    label: value,
    value: SystemImportItemCode[key],
  });
});
</script>
